import AddNewProduct from "../pages/admin/products/ProductForm.vue";
import AddNewCategory from "../pages/admin/products/CategoryForm.vue";
import Backup from "../pages/admin/Backups.vue";
import Buy from "../pages/admin/buy/Index.vue";
import Error404 from "../pages/errors/Error404.vue";
import Error408 from "../pages/errors/Error408.vue";
import Error500 from "../pages/errors/Error500.vue";
import ErrorLayout from "../components/ErrorLayout.vue";
import ForgetPassword from "../pages/auth/ForgetPassword.vue";
import GuestLayout from "../components/GuestLayout.vue";
import Login from "../pages/auth/Login.vue";
import MasterLayout from "../components/MasterLayout.vue";
import ProductMain from "../pages/admin/products/Index.vue";
import ProductsList from "../pages/admin/products/Products.vue";
import ProductsCategories from "../pages/admin/products/Categories.vue";
import ResetPassword from "../pages/auth/ResetPassword.vue";
import SettingBilling from "../pages/admin/setting/BillingSetting.vue";
import Setting from "../pages/admin/Setting.vue";
import SettingGeneral from "../pages/admin/setting/GeneralSetting.vue";
import SettingLogo from "../pages/admin/setting/LogoSetting.vue";
import SettingMail from "../pages/admin/setting/MailSetting.vue";
import SettingTandC from "../pages/admin/setting/TermsSetting.vue";
import SettingPos from "../pages/admin/setting/PosSetting.vue";
import UsersMain from "../pages/admin/user/Index.vue";
import Users from "../pages/admin/user/User.vue";

import ReportsMain from "../pages/admin/reports/Index.vue";
import SalesReport from "../pages/admin/reports/SaleOrders.vue";
import RefundsReport from "../pages/admin/reports/ReturnOrders.vue";
import PaymentReport from "../pages/admin/reports/Payments.vue";
import TaxReport from "../pages/admin/reports/TaxCollection.vue";
import TopProductsReport from "../pages/admin/reports/TopProducts.vue";
import PurchaseOrdersReport from "../pages/admin/reports/PurchaseOrders.vue";
import PendingPaymentsReport from "../pages/admin/reports/PendingPayments.vue";
import OverallStockCountsReport from "../pages/admin/reports/StocksOverall.vue";
import ContactsMain from "../pages/admin/contacts/Index.vue";
import CustomersList from "../pages/admin/contacts/CustomersList.vue";
import SuppliersList from "../pages/admin/contacts/SuppliersList.vue";
import StocksMain from "../pages/admin/stocks/Index.vue";
import WarehousesList from "../pages/admin/stocks/WarehousesList.vue";
import StocksList from "../pages/admin/stocks/StocksList.vue";
import InventoryMain from "../pages/admin/inventory/Index.vue";
import OutOfStcokItems from "../pages/admin/inventory/OutOfStockItems.vue";
import OutOfStockAlerts from "../pages/admin/inventory/OutOfStockAlerts.vue";
import StocksTracking from "../pages/admin/inventory/StockTracking.vue";
import TransactionMain from "../pages/admin/transaction/Index.vue";
import SaleTransaction from "../pages/admin/transaction/SaleTransactions.vue";
import RefundTransaction from "../pages/admin/transaction/ReturnTransactions.vue";
import PurchaseTransaction from "../pages/admin/transaction/PurchaseTransactions.vue";
import BuyBySuppilier from "../pages/admin/buy/BySupplier.vue";
import BuyByProduct from "../pages/admin/buy/ByProduct.vue";
import PaymentsMain from "../pages/admin/payment/Index.vue";
import PrintLayout from "../components/PrintLayout.vue";
import PrintPurchase from "../pages/admin/print/PurchaseInvoice.vue";
import PurchaseTransactionDetails from "../pages/admin/transaction/PurchaseTransactionDetails.vue";
import PaymentDetails from "../pages/admin/payment/PaymentDetails.vue";
import WarehouseForm from "../pages/admin/stocks/WarehouseForm.vue";
import CustomerForm from "../pages/admin/contacts/CustomerForm.vue";
import SupplierForm from "../pages/admin/contacts/SupplierForm.vue";
import WarehouseDetail from "../pages/admin/stocks/WarehouseDetail.vue";
import SupplierDetail from "../pages/admin/contacts/SupplierDetail.vue";
import CustomerDetail from "../pages/admin/contacts/CustomerDetail.vue";
import PosLayout from "../components/PosLayout.vue";
import Sale from "../pages/admin/sale/Index.vue";
import PrintSale from "../pages/admin/print/SaleInvoice.vue";
import SaleDetail from "../pages/admin/transaction/SaleTransactionDetails.vue";
import ProductDetail from "../pages/admin/products/ProductDetail.vue";
import ProductLabel from "../pages/admin/print/ProductLabel.vue";
import Dashboard from "../pages/admin/Dashboard.vue";
import PrintRefund from "../pages/admin/print/RefundInvoice.vue";
import RefundDetail from "../pages/admin/transaction/RefundTransactionDetails.vue";
import ShippingAddress from "../pages/admin/print/ShippingInfo.vue";
import RepiarForm from "../pages/admin/repair/RepairForm.vue";
import RepiarList from "../pages/admin/repair/RepairList.vue";
import RepiarPrint from "../pages/admin/print/RepairPrint.vue";
import PublicLayout from "../components/PublicLayout.vue";
import Track from "../pages/admin/repair/RepairTrack.vue";
import BillList from "../pages/admin/bill/BillList.vue";
import BillForm from "../pages/admin/bill/BillForm.vue";
import BillPrint from "../pages/admin/print/BillPrint.vue";
import Gallery from "../pages/admin/gallery/List.vue";
import GalleryList from "../pages/admin/gallery/GalleryList.vue";
import Shopping from "../pages/admin/shopList/Shopping.vue";
import CustomIndex from "../pages/admin/customBuy/Index.vue";
import CustomProductForm from "../pages/admin/customBuy/CustomProduct.vue";
import CustomProductList from "../pages/admin/customBuy/CustomProducts.vue";
import CustomProductDetails from "../pages/admin/customBuy/CustomProductDetail.vue";
import CustomBuyPrint from "../pages/admin/print/CustomBuyPrint.vue";
import ShopList from "../pages/admin/shopList/ShopList.vue";
import SettingUnits from "../pages/admin/setting/ProductUnits.vue";
import Announcement from "../pages/admin/setting/Announcement.vue";
export const routes = [
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "/",
        redirect: "/Welcome",
      },
      {
        path: "/shop",
        component: Shopping,
        meta: {
          title: "Shopping list",
          guest: true,
        },
      },
      {
        path: "/gallery",
        component: Gallery,
        meta: {
          title: "Repairing Gallery",
          guest: true,
        },
      },
      {
        path: "track/:key?",
        component: Track,
        meta: {
          title: "Tracking repair",
          guest: true,
        },
      },
    ],
  },
  {
    path: "/",
    component: MasterLayout,
    children: [
      {
        path: "/",
        redirect: { name: "Dashboard" },
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "products",
        component: ProductMain,
        children: [
          {
            path: "/",
            name: "Products",
            redirect: { name: "ProductsList" },
          },
          {
            path: "list",
            name: "ProductsList",
            component: ProductsList,
            meta: {
              title: "Products list",
            },
          },

          {
            path: "categories",
            name: "ProductsCategories",
            component: ProductsCategories,
            meta: {
              title: "Products categories",
            },
          },
          {
            path: "add-new-product",
            name: "AddNewProduct",
            component: AddNewProduct,
            meta: {
              title: "Add new product",
              gate: "productCreate",
            },
          },
          {
            path: "edit-product/:id",
            name: "EditProduct",
            component: AddNewProduct,
            meta: {
              title: "Edit product",
              gate: "productEdit",
            },
          },
          {
            path: "add-new-category",
            name: "AddNewCategory",
            component: AddNewCategory,
            meta: {
              title: "Add new category",
              gate: "categoryCreate",
            },
          },
          {
            path: "edit-category/:id",
            name: "EditCategory",
            component: AddNewCategory,
            meta: {
              title: "Edit category",
              gate: "categoryEdit",
            },
          },
          {
            path: "product-detail/:id",
            name: "ProductDetail",
            component: ProductDetail,
            meta: {
              title: "Product detail",
              gate: "productDetail",
            },
          },
        ],
      },

      {
        path: "custom",
        component: CustomIndex,
        children: [
          {
            path: "/",
            redirect: { name: "CustomProductList" },
          },
          {
            path: "custom-products",
            name: "CustomProductList",
            component: CustomProductList,
            meta: {
              title: "Product buy from customer",
              gate: "customProductManage",
            },
          },
          {
            path: "custom-product-details/:id",
            name: "CustomProductDetails",
            component: CustomProductDetails,
            meta: {
              title: "Custom product details",
            },
          },
          {
            path: "custom-product/:id?",
            name: "CustomProductForm",
            component: CustomProductForm,
            meta: {
              title: "Custom products ",
            },
          },
        ],
      },

      {
        path: "purchase",
        component: Buy,
        meta: {
          title: "Purchase",
          gate: "purchaseCreate",
        },
        children: [
          {
            path: "/",
            name: "Buy",
            redirect: { name: "BuyBySuppilier" },
          },
          {
            path: "by-supplier",
            name: "BuyBySuppilier",
            component: BuyBySuppilier,
            meta: {
              title: "Buy products with supplier",
            },
          },
          {
            path: "by-product",
            name: "BuyByProduct",
            component: BuyByProduct,
            meta: {
              title: "Buy products ",
            },
          },
        ],
      },
      {
        path: "reports",
        component: ReportsMain,
        meta: {
          title: "Systematic Reports",
          gate: "reports",
        },
        children: [
          {
            path: "/",
            name: "Reports",
            redirect: { name: "SalesReport" },
          },

          {
            path: "sales",
            name: "SalesReport",
            component: SalesReport,
            meta: {
              title: "Sales report",
              gate: "reports",
            },
          },
          {
            path: "return-orders",
            name: "RefundsReport",
            component: RefundsReport,
            meta: {
              title: "Sale refund report",
              gate: "reports",
            },
          },
          {
            path: "payments",
            name: "PaymentReport",
            component: PaymentReport,
            meta: {
              title: "Overall payments",
              gate: "reports",
            },
          },

          {
            path: "tax",
            name: "TaxReport",
            component: TaxReport,
            meta: {
              title: "Tax report",
              gate: "reports",
            },
          },
          {
            path: "top-products",
            name: "TopProductsReport",
            component: TopProductsReport,
            meta: {
              title: "Top sold product report",
              gate: "reports",
            },
          },

          {
            path: "purchase-orders-report",
            name: "PurchaseOrdersReport",
            component: PurchaseOrdersReport,
            meta: {
              title: "Purchase report",
              gate: "reports",
            },
          },
          {
            path: "purchase-payments-report",
            name: "PendingPaymentsReport",
            component: PendingPaymentsReport,
            meta: {
              title: "Pending payments reports",
              gate: "reports",
            },
          },
          {
            path: "overall-stock-calculation-report",
            name: "OverallStockCountsReport",
            component: OverallStockCountsReport,
            meta: {
              title: "Overall stock counts report",
              gate: "reports",
            },
          },
        ],
      },
      {
        path: "contacts/",
        component: ContactsMain,
        meta: {
          title: "Contacts",
        },
        children: [
          {
            path: "/",
            name: "Contacts",
            redirect: { name: "SuppliersList" },
          },

          {
            path: "customers",
            name: "CustomersList",
            component: CustomersList,
            meta: {
              title: "Customers list",
            },
          },
          {
            path: "add-new-customer",
            name: "AddNewCustomer",
            component: CustomerForm,
            meta: {
              title: "Add new customer",
              gate: "customerCreate",
            },
          },
          {
            path: "edit-customer/:id",
            name: "EditCustomer",
            component: CustomerForm,
            meta: {
              title: "Edit new customer",
              gate: "customerEdit",
            },
          },
          {
            path: "suppliers",
            name: "SuppliersList",
            component: SuppliersList,
            meta: {
              title: "Suppliers list",
            },
          },
          {
            path: "add-new-supplier",
            name: "AddNewSupplier",
            component: SupplierForm,
            meta: {
              title: "Add new supplier",
              gate: "supplierCreate",
            },
          },
          {
            path: "edit-supplier/:id",
            name: "EditSupplier",
            component: SupplierForm,
            meta: {
              title: "Edit supplier",
              gate: "supplierEdit",
            },
          },
          {
            path: "supplier-detail/:id",
            name: "SupplierDetail",
            component: SupplierDetail,
            meta: {
              title: "Supplier details",
              gate: "supplierDetials",
            },
          },
          {
            path: "customer-detail/:id",
            name: "CustomerDetail",
            component: CustomerDetail,
            meta: {
              title: "Customer details",
              gate: "customerDetials",
            },
          },
        ],
      },
      {
        path: "stocks-in-warehouses",
        component: StocksMain,
        meta: {
          title: "Stocks in warehouses",
        },
        children: [
          {
            path: "/",
            name: "Stocks",
            redirect: { name: "WarehousesList" },
          },
          {
            path: "warehouses",
            name: "WarehousesList",
            component: WarehousesList,
            meta: {
              title: "Product warehouses",
            },
          },
          {
            path: "add-new-warehouse",
            name: "AddNewWarehouse",
            component: WarehouseForm,
            meta: {
              title: "Add new warehouse",
              gate: "warehouseCreate",
            },
          },
          {
            path: "warehouse-details/:id",
            name: "WarehouseDetail",
            component: WarehouseDetail,
            meta: {
              title: "Warehouse detail",
              gate: "warehouseDetials",
            },
          },
          {
            path: "edit-warehouse/:id",
            name: "EditWarehouse",
            component: WarehouseForm,
            meta: {
              title: "Edit warehouse",
              gate: "warehouseEdit",
            },
          },
          {
            path: "product-stocks",
            name: "StocksList",
            component: StocksList,
            meta: {
              title: "Product stocks",
            },
          },
        ],
      },
      {
        path: "inventory",
        component: InventoryMain,
        meta: {
          title: "Inventory alert and tracking",
        },
        children: [
          {
            path: "/",
            name: "Inventory",
            redirect: { name: "OutOfStockAlerts" },
          },
          {
            path: "low-quantity-alerts",
            name: "OutOfStockAlerts",
            component: OutOfStockAlerts,
            meta: {
              title: "Low quantity alerts",
            },
          },
          {
            path: "out-of-stock-products-list",
            name: "OutOfStcokItems",
            component: OutOfStcokItems,
            meta: {
              title: "Out of stock items",
              gate: "outOfstock",
            },
          },
          {
            path: "stock-tracking",
            name: "StocksTracking",
            component: StocksTracking,
            meta: {
              title: "Stocks tracking",
              gate: "stockTracking",
            },
          },
        ],
      },
      {
        path: "debits-and-credit-payments",
        name: "Payments",
        component: PaymentsMain,
        meta: {
          title: "All Payments",
        },
      },
      {
        path: "payment-details/:id",
        name: "PaymentDetails",
        component: PaymentDetails,
        meta: {
          title: "Payment Details",
          gate: "paymentDetails",
        },
      },
      {
        path: "repair-lists",
        name: "RepiarList",
        component: RepiarList,
        meta: {
          title: "Repairing list",
          gate: "repairManage",
        },
      },
      {
        path: "repairing-gallery",
        name: "GalleryList",
        component: GalleryList,
        meta: {
          title: "Repairing gallery ",
          gate: "repairGalleryManage",
        },
      },
      {
        path: "shop-list",
        name: "ShopList",
        component: ShopList,
        meta: {
          title: "Shop listing ",
          gate: "shopListManage",
        },
      },
      {
        path: "bill-list",
        name: "BillList",
        component: BillList,
        meta: {
          title: "Billing list",
          gate: "billManage",
        },
      },
      {
        path: "repair-form/:id?",
        name: "RepiarForm",
        component: RepiarForm,
        meta: {
          title: "Repairing",
        },
      },
      {
        path: "bill-form/:id?",
        name: "BillForm",
        component: BillForm,
        meta: {
          title: "Billing",
        },
      },
      {
        path: "transactions",
        component: TransactionMain,
        meta: {
          title: "Transactions",
        },
        children: [
          {
            path: "/",
            name: "TransactionMain",
            redirect: { name: "SaleTransaction" },
          },
          {
            path: "sale",
            name: "SaleTransaction",
            component: SaleTransaction,
            meta: {
              title: "Sale transactions",
            },
          },
          {
            path: "sale-detail/:id",
            name: "SaleDetail",
            component: SaleDetail,
            meta: {
              title: "Sale detail",
              gate: "saleDetails",
            },
          },
          {
            path: "refund",
            name: "RefundTransaction",
            component: RefundTransaction,
            meta: {
              title: "Sale return transactions",
            },
          },
          {
            path: "refund-detail/:id",
            name: "RefundDetail",
            component: RefundDetail,
            meta: {
              title: "Sale return detail",
              gate: "refundDetails",
            },
          },
          {
            path: "purchase",
            name: "PurchaseTransaction",
            component: PurchaseTransaction,
            meta: {
              title: "Purchase transactions",
            },
          },
          {
            path: "purchase-details/:id",
            name: "PurchaseTransactionDetails",
            component: PurchaseTransactionDetails,
            meta: {
              title: "Purchase transactions details",
              gate: "purchaseDetails",
            },
          },
        ],
      },

      {
        component: Backup,
        name: "Backup",
        path: "backup-and-restore",
        meta: {
          title: "Backup And Restore",
          gate: "backups",
        },
      },

      {
        path: "users",
        component: UsersMain,
        meta: {
          title: "Users And Roles ",
        },
        children: [
          {
            path: "/",
            redirect: { name: Users },
          },
          {
            path: "list",
            name: "Users",
            component: Users,
            meta: {
              title: "User list",
              gate: "userManage",
            },
          },
        ],
      },
      {
        component: Setting,
        path: "settings",
        children: [
          {
            path: "/",
            name: "Settings",
            redirect: { name: "General" },
          },
          {
            path: "general",
            component: SettingGeneral,
            name: "General",
            meta: {
              title: "App General Setting",
              gate: "generalSetting",
            },
          },
          {
            path: "mail",
            component: SettingMail,
            meta: {
              title: "Mail Outgoing Configuration",
              gate: "mailSetting",
            },
          },
          {
            path: "logo",
            component: SettingLogo,
            meta: {
              title: "App Logo Setup",
              gate: "logoSetting",
            },
          },
          {
            path: "terms-and-conditions",
            component: SettingTandC,
            name: SettingTandC,
            meta: {
              title: "Billing terms and conditions",
              gate: "termsSetting",
            },
          },
          {
            path: "pos-configs",
            component: SettingPos,
            name: SettingPos,
            meta: {
              title: "POS Configuration",
            },
          },
          {
            path: "billing",
            component: SettingBilling,
            name: SettingBilling,
            meta: {
              title: "Billing Configuration",
            },
          },
          {
            path: "units",
            component: SettingUnits,
            name: SettingUnits,
            meta: {
              title: "Units Configuration",
            },
          },
          {
            path: "announcement",
            component: Announcement,
            name: Announcement,
            meta: {
              title: "Announcement",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/print",
    component: PrintLayout,
    children: [
      {
        path: "custom-purchase/:id",
        name: "CustomBuyPrint",
        component: CustomBuyPrint,
        meta: {
          title: "Custom buy print",
        },
      },
      {
        path: "purchase-invoice/:id",
        name: "PrintPurchase",
        component: PrintPurchase,
        meta: {
          title: "Print purchase invoice",
          gate: "purchaseDetails",
        },
      },
      {
        path: "print-sale/:id",
        name: "PrintSale",
        component: PrintSale,
        meta: {
          title: "Print sale recipient",
          gate: "salePrint",
        },
      },
      {
        path: "shipping-address/:id",
        name: "ShippingAddress",
        component: ShippingAddress,
        mata: {
          title: "Printing shipping address",
        },
      },
      {
        path: "print-sale-refund/:id",
        name: "PrintRefund",
        component: PrintRefund,
        meta: {
          title: "Print sale return recipient",
          gate: "refundPrint",
        },
      },
      {
        path: "product-label/:id",
        name: "ProductLabel",
        component: ProductLabel,
        meta: {
          title: "Product label",
          gate: "productLabel",
        },
      },
      {
        path: "repair-print/:id",
        name: "RepiarPrint",
        component: RepiarPrint,
        meta: {
          title: "Print Repair invoice",
        },
      },
      {
        path: "bill-print/:id",
        name: "BillPrint",
        component: BillPrint,
        meta: {
          title: "Print bill invoice",
        },
      },
    ],
  },
  {
    path: "/pos",
    name: "Pos",
    component: PosLayout,
    meta: {
      titel: "point-of-sale",
    },
    children: [
      {
        path: "portal/:trax?",
        name: "PosSale",
        component: Sale,
        meta: {
          title: "Point Of Sale",
          gate: "saleCreate",
        },
      },
    ],
  },
  {
    path: "/",
    component: GuestLayout,
    children: [
      {
        path: "/",
        redirect: { name: "Login" },
      },
      {
        path: "login",
        component: Login,
        name: "Login",
        meta: {
          title: "Welcome To Login ",
        },
      },
      {
        path: "forget-password",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
          title: "Forget Your Password ",
          guest: true,
        },
      },
      {
        path: "reset-password/:token",
        component: ResetPassword,
        name: "ResetPassword",
        meta: {
          title: "Reset Your Password ",
          guest: true,
        },
      },
    ],
  },

  {
    path: "/",
    component: ErrorLayout,
    children: [
      {
        name: "Error408",
        path: "request-timeout",
        component: Error408,
        meta: {
          title: "Error 408 Request timeout",
        },
      },
      {
        path: "internal-server-error",
        component: Error500,
        name: "Error500",
        meta: {
          title: "Error 500 Internal server error",
        },
      },
      {
        path: "*",
        name: "Error404",
        component: Error404,
        meta: {
          title: "Error 404 Page not found",
        },
      },
    ],
  },
];
